import React from'react'
import { createStore, combineReducers, applyMiddleware,Reducer } from "redux";
import thunk from "redux-thunk";
import { composeWithDevTools } from "redux-devtools-extension";
import { authReducer } from "../reducer/auth.reducer";
// import { userReducer } from "../reducer/user.reducer";
import { bellReducer } from "../reducer/bell.reducer";
import { snackBarReducer } from "../reducer/snackBar.reducer";
import { matterMostReducer } from "../reducer/matterMost.reducer";
import { i18nReducer } from "../reducer/i18n.reducer";
import { navBarReducer } from "../reducer/navBar.reducer";

import projectReducer  from "../reducer/project.reducer";
import scenarioReducer  from "../reducer/scenario.reducer";

// import {loggerStoreParam} from './utility';

const rootReducer = combineReducers({
  authReducer,
  // userReducer,
  bellReducer,
  projectReducer,
  snackBarReducer,
  matterMostReducer,
  i18nReducer,
  navBarReducer,
  scenarioReducer
});
const store = createStore(
  rootReducer,
  composeWithDevTools(
    applyMiddleware(
      thunk,
      // loggerStoreParam(process.env.NODE_ENV==="development")
    ))
);
export default store;

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootStoreState = ReturnType<typeof store.getState>
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppStoreDispatch = typeof store.dispatch
